import { SfConnector } from "common/sf-connector";
import { SFPackageVersion } from "sf-app/sf-package";

export interface IAnnouncement {
    name: string;
    releasedOn: Date;
    description: string;
    showUntil: SFPackageVersion;
    moduleIdentifier: string;
}

const ANNOUNCEMENTS : IAnnouncement[] = []
export class CQAnnouncement {
    applicableAnnouncements : IAnnouncement[];
    constructor() {
        this.applicableAnnouncements = [];
    }

    async initialize(connector: SfConnector ) {
        let packages = await connector.getInstalledPackageVersions();

        this.applicableAnnouncements = ANNOUNCEMENTS.filter(announcement => {
            let module = packages[announcement.moduleIdentifier];
            
            return (module && module.isOlderThan(announcement.showUntil)) || (!module);
        });
    }

    get announcements() {
        return this.applicableAnnouncements;
    }
}

const DefaultAnnouncements = new CQAnnouncement();

export default DefaultAnnouncements;